/**
 * Notifications domain — admin UI registration (Sub-project III, Task 9).
 *
 * Registers NotificationActions for notifications.platformnotification
 * with three bespoke actions: resend, mark-as-sent, soft-delete.
 */
import { registerAdminUI } from '@/admin/generic/registry';
import NotificationActions from './components/NotificationActions.vue';

registerAdminUI('notifications.platformnotification', {
    slots: {
        detailHeader: NotificationActions,
    },
});
